<template>
    <settings-control label="Border Radius" expand>
        <slider
            :value="sliderIndex"
            :values="borderRadiusValues"
            hide-marks
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import { tailwindConfig } from '@/data/tailwind';
import { tailwindThemePropSort } from '@/utils/tailwind-helper';

const configValues = tailwindConfig.theme.borderRadius;

export default {
    name: 'settings-control-border-radius',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            borderRadiusValues: Object.values(configValues)
                .filter((val) => {
                    const isRem = val.includes('rem');
                    const isMax = val === '50%';

                    return isRem || isMax;
                })
                .sort(tailwindThemePropSort),
            sliderIndex: 0,
        };
    },

    watch: {
        value: {
            handler(newVal) {
                this.sliderIndex = this.borderRadiusValues.indexOf(newVal);
            },
            immediate: true,
        },
    },

    methods: {
        onInput(index) {
            this.$emit('input', {
                tailwindDefinitionProp: 'borderRadius',
                value: this.borderRadiusValues[index],
            });
        },
    },
};
</script>
